import { gql } from "@apollo/client";

export const OrgChartUserNodeFragment = gql`
  fragment OrgChartUserNode on UserNode {
    id
    name
    avatar
    status
    primaryManager {
      id
    }
    managers(first: 1) {
      edges {
        node {
          id
        }
      }
    }
    currentRoles {
      id
      title
    }
    teamsList {
      id
    }
  }
`;

export default gql`
  ${OrgChartUserNodeFragment}
  query getOrgChartOrganizationMembersQuery(
    $organizationId: Int!
    $userIsActive: Boolean
    $after: String
  ) {
    organization(pk: $organizationId) {
      id
      members(
        membershipStatus: active
        userIsActive: $userIsActive
        first: 200
        after: $after
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            user {
              ...OrgChartUserNode
            }
          }
        }
      }
    }
  }
`;
